var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export default class FetchRequest {
    get priority() {
        return this._priority;
    }
    set priority(value) {
        this._priority = value;
    }
    constructor(_url, _data, _sessionContainer, _numOfRetriesBeforeReject, _cacheContainer, _cacheKey) {
        this.numOfRetriesBeforeReject = _numOfRetriesBeforeReject;
        this.url = _url;
        this.cacheKey = _cacheKey;
        this.data = _data;
        this.sessionContainer = _sessionContainer;
        this.amountOfTries = 0;
        this.cacheContainer = _cacheContainer;
        this._priority = 0;
        this.generateHeadersWithAuthorization = this.generateHeadersWithAuthorization.bind(this);
    }
    generateHeaders() {
        return this.generateHeadersWithAuthorization();
    }
    generateContentTypetData() {
        let result = "application/json";
        // console.log(this.data.body.constructor);
        if (this.data.body && this.data.body.constructor === FormData) {
            result = "multipart/form-data";
            console.log("Making form data");
            return undefined; //Я был не бухой, там реал косяк
        }
        return result;
    }
    generateAnonymousHeaders() {
        let headers = {
            'Accept': '*/*',
            "mode": 'cors',
        };
        let contentType = this.generateContentTypetData();
        if (contentType) {
            headers['Content-Type'] = this.generateContentTypetData();
        }
        return headers;
    }
    generateHeadersWithAuthorization() {
        // alert(JSON.stringify(this.chatApp));
        // alert(JSON.stringify(this.chatApp.sessionContainer));
        // alert(JSON.stringify(this.chatApp.sessionContainer.jwtContainer));
        let jwtContainer = this.sessionContainer.jwtContainer;
        let headers = {};
        if (!jwtContainer) {
            headers = {
                'Accept': '*/*',
                "mode": 'cors'
            };
        }
        else {
            headers = {
                'Accept': '*/*',
                "mode": 'cors',
                "Authorization": jwtContainer.content,
                "csrf": jwtContainer.csrf
            };
        }
        let contentType = this.generateContentTypetData();
        if (contentType) {
            headers['Content-Type'] = this.generateContentTypetData();
        }
        return headers;
    }
    perform() {
        return __awaiter(this, void 0, void 0, function* () {
            let me = this;
            return new Promise((resolve, reject) => {
                me.amountOfTries += 1;
                let data = Object.assign({}, me.data);
                data.headers = this.generateHeaders();
                console.log(this.url);
                return fetch(this.url, data).then((e) => {
                    if (!e.ok) {
                        me.amountOfTries += 1;
                        reject(e);
                        return;
                    }
                    if (me.isBlob) {
                        return e.blob();
                    }
                    return e.json();
                }).then((_res) => {
                    if (_res) {
                        if (me.sessionContainer.jwtContainer)
                            if (_res.csrf)
                                me.sessionContainer.jwtContainer.csrf = _res.csrf;
                    }
                    resolve(_res);
                }).catch((e) => {
                    console.log("Caught error");
                    console.log(e);
                    me.amountOfTries += 1;
                    console.log("Rejecting");
                    reject(e);
                });
            });
        });
    }
    make() {
        let me = this;
        let promise = new Promise((_resolve, _reject) => {
            me.madeResolve = _resolve;
            me.madeReject = _reject;
        });
        return promise;
    }
}
